(() => {
  // Only enhance product accordions
  const accordions = document.querySelectorAll('.product__accordion details');

  if (!accordions.length) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  accordions.forEach((details) => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');

    if (!summary || !content) return;

    // Avoid double-binding
    if (details.dataset.smoothAccordion === 'true') return;
    details.dataset.smoothAccordion = 'true';

    summary.addEventListener('click', (e) => {
      // Let keyboard interaction still work; we're only changing animation
      e.preventDefault();

      if (prefersReducedMotion) {
        details.open = !details.open;
        return;
      }

      const isOpen = details.open;

      // Prepare content for animation
      content.style.overflow = 'hidden';

      if (!isOpen) {
        // OPEN
        details.open = true;

        // Start from 0 height
        content.style.height = '0px';

        // Measure target height
        const target = content.scrollHeight;

        requestAnimationFrame(() => {
          content.style.transition = 'height 280ms ease';
          content.style.height = `${target}px`;
        });

        const onEnd = (evt) => {
          if (evt.propertyName !== 'height') return;
          content.removeEventListener('transitionend', onEnd);

          // Clean up so content can reflow naturally
          content.style.transition = '';
          content.style.height = '';
          content.style.overflow = '';
        };

        content.addEventListener('transitionend', onEnd);
      } else {
        // CLOSE
        const start = content.getBoundingClientRect().height;
        content.style.height = `${start}px`;

        requestAnimationFrame(() => {
          content.style.transition = 'height 260ms ease';
          content.style.height = '0px';
        });

        const onEnd = (evt) => {
          if (evt.propertyName !== 'height') return;
          content.removeEventListener('transitionend', onEnd);

          details.open = false;

          // Clean up
          content.style.transition = '';
          content.style.height = '';
          content.style.overflow = '';
        };

        content.addEventListener('transitionend', onEnd);
      }
    });
  });
})();
